<template>
  <div class="header" id="header">
    <div class="head index_contain clearfix">
      <img v-show="logo" :src="logo" style="height: 40px;margin-top: 12px" />
      <!-- <div class="toolsBar fr">
        <div class="login fr">
          <el-button>登录</el-button>
          <el-button type="danger">注册</el-button>
        </div>
        <div class="search fr">
          <el-input placeholder="请输入搜索内容" v-model="input5" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>-->
      <div class="login">
        <el-button type="primary" size="mini" v-if="!login" @click="senddata">登录</el-button>
        <!-- v-if="!login" -->
        <div class="loginbox" v-if="login">
          <el-popover placement="bottom" width="108" trigger="click" popper-class="customPopper" style="min-width: 108px !important;">
            <a class="loginurl" slot="reference">
              <img :src="imgsrc" />
            </a>
            <div class="wenzitl" @click="geRen" style="text-align: center;font-size: 14px;color: #202020;display: flex;justify-content: center;">
              <img style="width: 14px;height: 14px;margin-top: 4px;" src="../assets/imgs/gezxt.png" alt="">
              <span style="margin-left: 8px">个人中心</span>
            </div>
            <div class="wenzitl" @click="logout" style="text-align: center;font-size: 14px;color: #202020;display: flex;justify-content: center;margin-top: 10px;">
              <img style="width: 14px;height: 14px;margin-top: 4px;" src="../assets/imgs/tcdlt.png" alt="">
              <span style="margin-left: 8px">退出登录</span>
            </div>
          </el-popover>
          <h3 style="color: white;text-overflow: ellipsis; overflow: hidden;max-width: 100px;white-space: nowrap;">
            {{ nicknc || "" }}
          </h3>
          <el-popover placement="top" width="160" v-model="visible2">
            <p>此操作将退出登录, 是否继续?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="visible2 = false">取消</el-button>
              <el-button type="primary" size="mini" @click="logout()">确定</el-button>
            </div>
            <!-- <el-button slot="reference">退出</el-button> -->
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tool from '@/kits/Tools.js'
import GLOBAL_CONFIG from '../../global/index'
export default {
  data () {
    return {
      input5: '',
      show: '',
      data: {
        header: '',
        nick: ''
      },
      ds_id: 0,
      channel_id: '',
      logo: '',
      visible2: false,
      logo01: GLOBAL_CONFIG.logoSrc,
      is_tengface: 0
    }
  },
  props: ['login', 'qrcodeShow', 'userLogin', 'imgsrc', 'nicknc'],
  async mounted () {
    this.ds_id = tool.getQueryString('ds_id')
    this.channel_id = tool.getQueryString('channel_id')
    try {
      if (!this.ds_id && this.channel_id) {
        const data = await this.axios.post(
          tool.baseUrl2() + '/customer/channel/getDsIdByChannelId',
          'channel_code=' + this.channel_id
        )
        if (data.data.code === 200) {
          this.ds_id = data.data.data.ds_id
        } else {
          this.$alert(data.data.message, '', {
            showConfirmButton: false,
            showClose: false,
            type: 'warning',
            center: true
          })
          return false
        }
      }
    } catch (e) {
      try {
        const data = await this.axios.get(
          tool.tencentOssUrl() + '/ds/channel_cache/channel_' + this.channel_id + '.json?' + new Date().getTime() + parseInt(Math.random() * 10e4), { timeout: 2000 })
        if (data) {
          this.ds_id = data.data.ds_id
        }
      } catch (e) {
        this.$alert('网络存在问题,请刷新重试', '', {
          showConfirmButton: false,
          showClose: false,
          type: 'warning',
          center: true
        })
        return false
      }
    }
    this.getLogo()
  },
  methods: {
    geRen () {
      this.$emit('geRendy')
    },
    changeFavicon (link) {
      let $favicon = document.querySelector('link[rel="icon"]')
      if ($favicon !== null) {
        $favicon.href = link
        // Otherwise, create a new element and append it to <head>.
      } else {
        $favicon = document.createElement('link')
        $favicon.rel = 'icon'
        $favicon.href = link
        document.head.appendChild($favicon)
      }
    },
    senddata: function () {
      this.show = !this.qrcodeShow
      $('#qrcode').addClass('bounceIn')
      this.$emit('send', true)
    },
    getLogo () {
      var that = this
      var option = 'ds_id=' + this.ds_id
      this.axios
        .post(this.beseUrl + '/login/getLogoWithDsid', option)
        .then(function (res) {
          var data = res.data.data
          // eslint-disable-next-line eqeqeq
          if (res.data.code == '200') {
            if (data[0].is_tengface === 1) { // 不显示
              if (data[0].logo_url) {
                that.logo = data[0].logo_url
              }
              if (data[0].header) {
                that.changeFavicon(data[0].header)
              }
            } else { // 显示
              that.logo = that.logo01
              that.changeFavicon(GLOBAL_CONFIG.iconSrc)
            }
          }
        })
    },
    logout () {
      this.$confirm('此操作将退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false
      })
        .then(() => {
          tool.logout()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    }
  },
  watch: {
    userLogin (curVal, oldVal) {
      if (curVal !== oldVal) {
        this.data = this.userLogin
      }
    }
  }
}
</script>
<style>
.customPopper {
  min-width: 108px !important;
}
</style>
<style scoped>
.wenzitl {
  cursor: pointer;
}
.wenzitl span:hover {
  color: #1872ED;
}
.header {
  height: 60px;
  border-bottom: 1px solid #242424;
  background: #242424;
  /*position: relative;
		z-index: 9999;*/
}
.index_contain {
  min-width: 1220px;
  /* max-width: 1504px; */
  margin-left: auto;
  margin-right: auto;
  padding: 0 5%;
  width: 100%;
  box-sizing: border-box;
}

.logo {
  margin-top: 14px;
}

.toolsBar {
  max-width: 800px;
  margin-top: 16px;
}

.head {
  margin-left: auto;
  margin-right: auto;
  position: relative;
}

.head .login {
  float: right;
  margin-top: 5px;
}

.loginbox .loginurl {
  width: 35px;
  height: 35px;
  margin-top: 8px;
  float: left;
}

.loginbox .loginurl img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.loginbox h3 {
  float: left;
  font-size: 15px;
  line-height: 50px;
  margin-left: 10px;
}

.el-button {
  margin: 10px 0px 0px 20px;
}

.logo img {
  height: 51px;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue